import { h } from 'preact';

const Rail = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path
				d="M8.164,1c0.644,0,1.167,0.522,1.167,1.167c0,0.644-0.522,1.167-1.167,1.167c-0.644,0-1.167-0.522-1.167-1.167
				C6.998,1.522,7.52,1,8.164,1z M7.817,3.722c0.471,0,0.877,0.262,1.092,0.646c0.117,0.126,1.302,2.593,1.302,2.593
				c0.028,0.007,1.69,0.314,1.69,0.314c0.287,0.037,0.513,0.273,0.51,0.572c0,0.323-0.261,0.585-0.585,0.585
				c-0.026,0-1.361-0.259-2.027-0.395c-0.242-0.049-0.446-0.205-0.56-0.423L8.734,6.646l-0.38,1.851l1.736,1.737
				c0.145,0.153,0.226,0.356,0.226,0.567l0.002,3.504l-0.006,0.094C10.266,14.739,9.975,15,9.623,15c-0.384,0-0.695-0.311-0.695-0.695
				c0-0.001,0-1.25,0.001-2.12v-0.819L7.15,9.587c0,0-0.31,1.867-0.338,2.012s-0.076,0.255-0.262,0.475
				c-0.167,0.198-2.2,2.684-2.2,2.684c-0.128,0.145-0.309,0.241-0.517,0.241c-0.384,0-0.695-0.311-0.695-0.696
				c0-0.174,0.071-0.329,0.177-0.451l1.838-2.309l0.537-3.06c0,0,0.53-2.584,0.572-2.708L5.683,6.099L4.751,7.843
				c-0.1,0.181-0.285,0.31-0.507,0.31c-0.323,0-0.585-0.262-0.585-0.585c0-0.082,0.018-0.16,0.049-0.232l1.005-1.892
				c0.074-0.14,0.183-0.253,0.321-0.331c0.587-0.329,2.185-1.24,2.185-1.24C7.404,3.78,7.602,3.722,7.817,3.722z"
			/>
		</svg>
	);
};

export default Rail;
